import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';

// Largeurs variées pour imiter des libellés de longueurs différentes
const LABEL_WIDTHS = ['55%', '80%', '65%', '70%', '45%', '60%'];
const HORIZONTAL_WIDTHS = [90, 150, 120, 110, 70, 85];

// Skeleton lisible sur le fond sombre du menu
const MenuBone = styled(Skeleton)({
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
});

// Mêmes dimensions qu'une entrée de premier niveau (StyledListItem), pour éviter un saut à l'affichage du vrai menu
const SidebarRow = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    minHeight: 44,
    padding: '10px 20px',
    'body.vertical-collpsed &': {
        padding: '12px 0',
        justifyContent: 'center',
        '& .menu-skeleton-label': { display: 'none' },
        '& .menu-skeleton-icon': { marginRight: 0 },
    },
});

const MenuSkeleton = ({ horizontal = false }: { horizontal?: boolean }) => {
    if (horizontal) {
        return (
            <Box aria-busy="true" sx={{ display: 'flex', alignItems: 'center', height: 40 }}>
                {HORIZONTAL_WIDTHS.map((width, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '6px', px: 3 }}>
                        <MenuBone variant="circular" width={16} height={16} />
                        <MenuBone variant="text" width={width} height={20} />
                    </Box>
                ))}
            </Box>
        );
    }

    return (
        <Box aria-busy="true">
            {LABEL_WIDTHS.map((width, index) => (
                <SidebarRow key={index}>
                    <MenuBone className="menu-skeleton-icon" variant="circular" width={18} height={18} sx={{ flexShrink: 0, mr: '22px' }} />
                    <MenuBone className="menu-skeleton-label" variant="text" width={width} height={18} />
                </SidebarRow>
            ))}
        </Box>
    );
};

export default MenuSkeleton;
